<template>	
	<div>
		<modal-dialog
			:modal-visible="visible"
			title="Edit Expense"
			confirm-button-text="Save"
			:submit-visible="record.processed == 0"
			:modal-size="modalSize"
			v-on:confirm="save"
			v-on:closeModal="closeModal">

			<div v-if="record.processed == 1" class="alert alert-warning" style="margin-top: -16px;margin-left: -15px;margin-right: -15px;">
				<i class="fa fa-lock"></i>
				This expense has already been processed, it is readonly.
			</div>
			<!--<div v-else-if="record.reviewed_by > 0 && !approvable" class="alert alert-warning" style="margin-top: -16px;margin-left: -15px;margin-right: -15px;">
				<i class="fa fa-exclamation-triangle"></i>
				This expense has already been reviewed, if you choose to edit it again, it will be toggled back to an <strong>unreviewed</strong> status
			</div>-->

			<div :class="{'row': hasPO}">

				<div :class="{'col-md-6': hasPO}">

					<template v-if="!readonly">

						<field 
							label="Employee" 
							col-class="col-md-4" 
							:readonly="userOptionsProp && userOptionsProp.length == 0"
							:params="{
								type: userOptionsProp && userOptionsProp.length == 0 ? 'text' : 'select',
								options: userOptionsProp
							}" 
							v-model="userOptionsProp && userOptionsProp.length == 0 && 'User' in record && record.User ? record.User.first_name+' '+record.User.last_name : payload.user_id">	
						</field>

						<job-picker
							v-if="payload.service_id == 0 || payload.service_id == null"
							col-class="col-md-4"
							job-type="project" 
							key="project"
							v-model="payload.job_id"
							v-on:change="jobChange">
						</job-picker>

						<job-picker
							v-if="payload.job_id == 0 || payload.job_id == null"
							col-class="col-md-4"
							job-type="service" 
							key="service"
							v-model="payload.service_id"
							v-on:change="jobChange">
						</job-picker>

						<field label="Subtotal" 
							col-class="col-md-4" 
							:params="{type:'number', step:0.01}" 
							v-model="payload.cost" 
							v-on:change="costChange">
						</field>

						<field v-if="qboIsActive"
							label="Tax Paid"
							col-class="col-md-4"
							:params="{type:'select',options:qboSalesTaxOptions}"
							v-model="payload.qbo_tax_id"
							v-on:change="calcQboTax($event)">
						</field>

						<field v-else
							label="Tax" 
							col-class="col-md-4" 
							:params="{type:'number', step:0.01}" 
							v-model="payload.tax"
							v-on:change="taxChange">		
						</field>

						<field label="Tip" 
							col-class="col-md-4" 
							:params="{type:'number', step:0.01}" 
							v-model="payload.tip">		
						</field>

						<field 
							label="Total" 
							col-class="col-md-4" 
							:value="calcExpenseTotal(payload)" 
							readonly="true">
						</field>

						<field label="Date of Purchase" 
							col-class="col-md-4" 
							:params="{type:'date'}" 
							v-model="payload.purchase_date">
						</field>

						<field label="Due Date" 
							col-class="col-md-4" 
							:params="{type:'date'}" 
							v-model="payload.due_date">
						</field>

						<field label="Purchase Order"
							col-class="col-md-4"
							:params="{type:'select',options: purchaseOrderOptions}"
							v-model="payload.purchase_order_id">
						</field>

						<field label="Expense Group" 
							col-class="col-md-4" 
							:params="{
								type: expenseGroupOptions.length == 0 ? 'text' : 'select',
								options:expenseGroupOptions
							}" 
							v-model="expenseGroupOptions.length == 0 && 'ExpenseGroup' in record && record.ExpenseGroup ? record.ExpenseGroup.group_name : payload.group_id" 
							v-on:change="groupSelected">	
						</field>

						<field label="Expense Code" 
							col-class="col-md-4" 
							:params="{
								type:expenseCodesFilteredOptions.length == 0 ? 'text' : 'select',
								options:expenseCodesFilteredOptions
							}" 
							v-model="expenseCodesFilteredOptions.length == 0 && 'ExpenseCode' in record && record.ExpenseCode ? record.ExpenseCode.code+': '+record.ExpenseCode.description : payload.code_id">
						</field>

						<field label="Description" 
							col-class="col-md-4" 
							:params="{type:'text'}" 
							v-model="payload.description">	
						</field>

						<field v-if="vendorSelection == 'options'"
							label="Vendor" 
							col-class="col-md-4"
							:params="{type:'select',options:supplierOptions}"
							:readonly="payload.purchase_order_id > 0"
							v-on:change="vendorSelectionChange"
							v-model="payload.supplier_id">

							<button v-if="payload.purchase_order_id == 0" class="btn btn-sm btn-light float-right mt-1" type="button" v-on:click="setVendorMode('manual')">Set Vendor Manually</button>	
						</field>

						<field v-else
							label="Vendor" 
							col-class="col-md-4"
							:params="{type:'text'}"
							v-model="payload.vendor">	

							<button class="btn btn-sm btn-light float-right mt-1" type="button" v-on:click="setVendorMode('options')">Select Vendor</button>	
						</field>

						<field
							label="Invoice No." 
							col-class="col-md-4"
							:params="{type:'text'}"
							v-model="payload.invoice_num">		
						</field>

						<field label="Payment Type" col-class="col-md-4"
							:params="{type:'select',options: [...expensePaymentTypeOptions,{value: 'Invoiced',text: 'Invoiced'}]}"
							v-model="payload.payment_method"
							v-on:change="paymentTypeChange">		
						</field>

						<template v-if="payload.payment_method == 'Business Card'">
							<field v-if="qboIsActive"
								label="Credit Card"
								col-class="col-6"
								:params="{type:'select',options:ccAccountOptions,required:true}"
								v-model="payload.qbo_account_id"
								:invalid="$store.qbo_account_id">
							</field>
							<field v-else 
								label="Last 4 Card Digits" 
								col-class="col-md-4" 
								:params="{type: 'text',required:true}"
								v-model="payload.last_4">	
							</field>
						</template>

					</template>
					<template v-else>

						<table class="table table-sm">
							<tbody v-if="userFullName && projectName">
								<tr>
									<th>Date Purchased</th>
									<td>{{ formatDate(record.purchase_date) }}</td>
								</tr>
								<tr>
									<th>Employee</th>
									<td><router-link :to="userFullName.link">{{ userFullName.text }}</router-link></td>
								</tr>
								<tr>
									<th>Project</th>
									<td><router-link :to="projectName.link">{{ projectName.text }}</router-link></td>
								</tr>
								<tr>
									<th>Expense Group</th>
									<td><field :params="{type:'select',options:expenseGroupOptions}" v-model="payload.group_id" v-on:change="groupSelected" :readonly="true"></field></td>
								</tr>
								<tr>
									<th>Expense Code</th>
									<td><field :params="{type:'select',options:expenseCodesFilteredOptions}" v-model="payload.code_id" :readonly="true"></field></td>
								</tr>
								<tr>
									<th>Cost</th>
									<td>{{ record.cost }}</td>
								</tr>
								<tr>
									<th>Tax</th>
									<td>{{ record.tax }}</td>
								</tr>
								<tr>
									<th>Tip</th>
									<td>{{ record.tip }}</td>
								</tr>
								<tr>
									<th>Total</th>
									<td><strong>{{ calcExpenseTotal(record) }}</strong></td>
								</tr>
								<tr>
									<th>Description</th>
									<td>{{ record.description }}</td>
								</tr>					
								<tr>
									<th>Vendor</th>
									<td>{{ record.vendor }}</td>
								</tr>
								<tr>
									<th>Payment Method</th>
									<td>{{ record.payment_method }}</td>
								</tr>
								<tr v-if="record.last_4">
									<th>Card</th>
									<td>{{ record.last_4 }}</td>
								</tr>
								
							</tbody>
						</table>

					</template>

					<form-group label="Receipt" col-class="col-md-4">
						<image-panel 
							:readonly="readonly"
							:image-url="imageUrl"
							:expand-url="expandImgUrl"
							:expand-on-click="true"
							:no-delete="true"
							v-on:rotate="rotateImg">
						</image-panel>
					</form-group>

					<template v-if="approvable && !readonly">
						<field label="Approved" col-class="col-md-4" :params="{type:'boolean'}" v-model="payload.approved" v-on:change="expenseApprovedToggle"></field>

						<field label="Denied" col-class="col-md-4" :params="{type:'boolean'}" v-model="payload.denied"  v-on:change="expenseDeniedToggle"></field>

						<field v-if="payload.denied == 1" label="Denied Reason" col-class="col-md-4" :params="{type:'textarea'}" v-model="payload.denied_reason"></field>
					</template>

					<form-group v-if="!showReviewHistory" label="Last Edited By" col-class="col-md-4">
						<div class="form-control-plaintext">
							<template v-if="record.UpdatedBy">
								{{record.UpdatedBy.first_name}} {{record.UpdatedBy.last_name}} @ {{record.updated_at}}
							</template>
						</div>
					</form-group>

					<template v-if="showReviewHistory">
						<h3>Edit/Review History</h3>

						<table class="table table-sm">
							<tbody>
								<tr>
									<th>Created</th>
									<td>{{ record.created_at }}</td>
								</tr>
								<tr>
									<th>Reviewed</th>
									<td>
										<span v-if="record.reviewed_by != 0">{{ reviewedByName }} @ {{ formatDateTimeToLocal(record.reviewed_at) }}</span>
										<i v-else class="fa fa-times"></i>
									</td>
								</tr>
								<tr v-if="record.reviewed_by > 0">
									<th>Approved/Denied</th>
									<td>
										<span v-if="record.approved == 1" class="text-success">Approved</span>
										<span v-else class="text-danger">Denied</span>
									</td>
								</tr>
								<tr v-if="record.reviewed_by > 0 && record.approved == 0">
									<th>Denied Reason</th>
									<td>
										{{record.denied_reason}}
									</td>
								</tr>
								<tr>
									<th>Processed</th>
									<td>
										<i :class="record.processed == 1 ? 'fa-check' : 'fa-times'" class="fa"></i>
									</td>
								</tr>
								<tr>
									<th>Last Edit</th>
									<td>
										<span v-if="record.UpdatedBy">{{ record.UpdatedBy.first_name }} {{ record.UpdatedBy.last_name }} @ {{ record.updated_at }}</span>
									</td>
								</tr>
							</tbody>
						</table>
					</template>

					<div class="d-flex">
						<button v-if="record.processed == 1" class="btn btn-light btn-sm" type="button" v-on:click="unprocessedConfirmModalVisible = true">
							<i class="fa fa-rotate-left"></i>
							Revert to Un-processed
						</button>

						<button v-if="record.reviewed_by > 0 && record.processed == 0 && hasModulePermWrite('Expenses')" class="btn btn-light btn-sm" type="button" v-on:click="unreviewConfirmModalVisible = true">
							<i class="fa fa-rotate-left"></i>
							Revert to Un-reviewed
						</button>
					</div>

					<comment-thread v-if="hasComments"
						:message-thread="payload.MessageThread"
						:parent-slug="record.slug"
						:thread-id="'message_thread_id' in record ? record.message_thread_id : false"
						parent-model="Expense"
						:thread-subject-reference="threadSubjectRef">			
					</comment-thread>
				</div>
				<div v-if="hasPO" class="col-md-6">
					<form-group label="Purchase Order" col-class="stacked">
						<pdf-js :url="poUrl"></pdf-js>
					</form-group>
				</div>
			</div>

			<template v-if="deleteable && !readonly" slot="footer">
				<button class="btn btn-outline-danger" type="button" v-on:click="deleteConfirmModalVisible = true">
					<i class="fa fa-trash"></i>
					Delete Expense
				</button>
			</template>
				
		</modal-dialog>

		<modal-dialog
			:modal-visible="deleteConfirmModalVisible"
			title="Delete Expense"
			confirm-button-text="Yes, Delete"
			button-class="btn-outline-danger"
			v-on:confirm="deleteExpense"
			v-on:closeModal="deleteConfirmModalVisible = false">

			Are you sure you want to delete this expense?
		</modal-dialog>

		<modal-dialog
			:modal-visible="unprocessedConfirmModalVisible"
			title="Revert to Un-processed"
			confirm-button-text="Yes, Revert to un-processed"
			button-class="btn-success"
			v-on:confirm="unProcess"
			v-on:closeModal="unprocessedConfirmModalVisible = false">

			Are you sure you want to revert this expense to an un-processed status?
		</modal-dialog>

		<modal-dialog
			:modal-visible="unreviewConfirmModalVisible"
			title="Revert to Un-reviewed"
			confirm-button-text="Yes, Revert to un-reviewed"
			button-class="btn-success"
			v-on:confirm="unReview"
			v-on:closeModal="unreviewConfirmModalVisible = false">

			Are you sure you want to revert this expense to an un-reviewed status? This will clear the <strong>Denied Reason</strong> field.
		</modal-dialog>
	</div>
</template>
<script type="text/javascript">
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import ImagePanel from "@/components/ImagePanel"
import CommentThread from "@/components/super_components/CommentThread"
import PdfJs from "@/components/PdfJs"
import JobPicker from "@/components/super_components/JobPicker"

import ExpenseMixins from "@/mixins/ExpenseMixins.js"

export default {
	name: "ExpenseEditModal",
	components: {
		ModalDialog,
		Field,
		FormGroup,
		ImagePanel,
		CommentThread,
		PdfJs,
		JobPicker
	},
	mixins: [ExpenseMixins],
	props: [
		"visible",
		"record", //required includes: User, UpdatedBy, ReceiptImage, ReviewedBy, MessageThread (if exists), PurchaseOrder (if exists)
		"approvable",
		"deleteable",
		"userOptionsProp",
		"showReviewHistory",
		"hasComments",
		"isReadonly"
	],
	data() {
		return {
			deleteConfirmModalVisible: false,
			unprocessedConfirmModalVisible: false,
			unreviewConfirmModalVisible: false,
			payload: {},
			expenseCodesFilteredOptions: [],
			imgUpdateRand: Math.random(),
			jobFields: ["id","slug","job_num","job_name","Customer"],
			suppliers: [],
			vendorSelection: "manual",
			purchaseOrders: []
		}
	},

	computed: {
		hasPO() {
			return this.record && 'PurchaseOrder' in this.record && this.record.PurchaseOrder
		},
		modalSize() {
			if ("purchase_order_id" in this.record && this.record.purchase_order_id > 0)
				return "modal-full"
			else
				return ""
		},
		threadSubjectRef() {
			if (this.payload && "description" in this.payload)
				return "Expense: "+this.payload.description
			else
				return "Expense"
		},
		readonly() {
			if (this.isReadonly)
				return true

			if (this.record && this.record.processed == 1)
				return true

			return false
		},
		imageUrl() {

			if (this.record && "ReceiptImage" in this.record) {

				let filename = this.record.ReceiptImage.filename
				if (this.record.ReceiptImage.thumb_filename)
					filename = this.record.ReceiptImage.thumb_filename

				return window.apiRoot+"resources/receipt-images/"+this.$store.sessionToken+"/"+filename+"?r="+this.imgUpdateRand
			}
			else
				return ""
		},
		expandImgUrl() {
			if (this.record && "ReceiptImage" in this.record) {

				let filename = this.record.ReceiptImage.filename

				return window.apiRoot+"resources/receipt-images/"+this.$store.sessionToken+"/"+filename+"?r="+this.imgUpdateRand
			}
			else
				return ""
		},
		poUrl() {
			let po = this.record.PurchaseOrder

			return window.apiBase+"PurchaseOrder/pdf?slug="+po.slug+"&token="+this.$store.sessionToken+"&humanReadable=true"
		},
		reviewedByName() {
			if ("ReviewedBy" in this.record)
				return this.record.ReviewedBy.first_name + " "+ this.record.ReviewedBy.last_name
			else
				return ""
		},
		userFullName() {
			if ("User" in this.record) {
				return {
					text: this.record.User.first_name + " " + this.record.User.last_name,
					link: "/employee/"+this.record.User.slug+"/profile"
				}
			}
		},
		projectName() {
			if (this.record.Service) {
				return {
					text: this.record.Service.job_num,
					link: "/service/"+this.record.Service.slug+"/dashboard"
				}
			}
			else if (this.record.Job) {
				return {
					text: this.record.Job.job_num+": "+this.record.Job.job_name,
					link: "/project/"+this.record.Job.slug+"/dashboard"
				}
			}
			else {
				return {
					text: "",
					link: ""
				}
			}
			
		},
		supplierOptions() {
			return this.optionify(this.suppliers,"name")
		},
		purchaseOrderOptions() {
			let vm = this
			return this.optionify(this.purchaseOrders.map(po => {

				let jobKey = false
				if ("Service" in po && po.Service)
					jobKey = "Service"
				else if ("Job" in po && po.Job)
					jobKey = "Job"

				if (jobKey)
					po.displayField = po[jobKey].job_num+"-"+po.po_num+": "+po.subject
				else
					po.displayField = po.po_num + ": " + po.subject

				return po
			}),"displayField")
		
		}
	},
	watch: {
		qboIsActive() {
			if (this.qboIsActive) {
				this.fetchQBOCreditCards()
				this.fetchQboSalesTaxes()
			}
		},
		visible() {

			if (this.$store.expenseGroups && this.$store.expenseGroups.length == 0) {
				let vm = this

				this.getJSON("ExpenseGroup/get").then(response => {
					if (response.success) {
						vm.$store.expenseGroups = response.data

						this.groupSelected(this.record.group_id,this.record.code_id)
					}
				})
			}
			else 
				this.groupSelected(this.record.group_id,this.record.code_id)
		},
		record() {
			this.setPayload()
		}
	},
	methods: {
		setPayload() {
			let vm = this

			this.payload = {
				code_id: this.record.code_id != 0 ? this.record.code_id : null,
			}

			let payloadFields = [
				"id",
				"user_id",
				"job_id",
				"service_id",
				"group_id",
				"cost",
				"tax",
				"tip",
				"description",
				"vendor",
				"invoice_num",
				"payment_method",
				"purchase_date",
				"due_date",
				"last_4",
				"qbo_account_id",
				"qbo_tax_id",
				"supplier_id",
				"denied_reason",
				"approved",
				"denied"
			]

			payloadFields.forEach(field => {
				vm.payload[field] = vm.record[field]
			})

			if (this.record.supplier_id > 0)
				this.vendorSelection = "options"
			else
				this.vendorSelection = "manual"

			if (this.record.reviewed_by > 0)
				this.payload.reviewed_by = this.record.reviewed_by

			if ("MessageThread" in this.record)
				this.payload.MessageThread = this.record.MessageThread

			this.groupSelected(this.record.group_id,this.record.code_id)

			if (this.purchaseOrders.length == 0 || !this.purchaseOrders.find(po => po.id == this.record.purchase_order_id)) {
				//fetch po list
				let job_id = "service_id" in this.record && this.record.service_id > 0 ? this.record.service_id : this.record.job_id
				let job_key = false
				if ("service_id" in this.record && this.record.service_id > 0)
					job_key = "service_id"
				else if ("job_id" in this.record && this.record.job_id > 0)
					job_key = "job_id"

				this.fetchJobPurchaseOrders(job_id,job_key).then(response => {
					vm.payload.purchase_order_id = vm.record.purchase_order_id
				})
			}
			else
				vm.payload.purchase_order_id = this.record.purchase_order_id

			if (this.qboIsActive)
				this.calcQboTax()
		},
		setVendorMode(mode) {
			this.vendorSelection = mode

			if (this.vendorSelection == 'manual') {
				let selection = this.suppliers.find(contact => contact.id == this.payload.supplier_id)

				if (selection)
					this.payload.vendor = selection.name

				this.payload.supplier_id = 0

			}
			else {
				let selection = this.suppliers.find(contact => contact.name == this.payload.vendor)

				if (selection)
					this.payload.supplier_id = selection.id
			}
		},
		vendorSelectionChange(supplierId) {
			let selection = this.suppliers.find(contact => contact.id == supplierId)

			if (selection) 
				this.payload.vendor = selection.name
		},
		jobChange(value) {
			this.$forceUpdate() //to allow both service and project selectors to be available
		},
		costChange(value) {
			this.$forceUpdate()
		},
		taxChange() {
			this.calcQboTax()
			this.$forceUpdate()
		},
		calcQboTax(codeId) {
			let vm = this

			if (this.qboIsActive) {

				if (!codeId)
					codeId = this.payload.qbo_tax_id

				this.$nextTick(() => {
					vm.getQboTaxRate(codeId).then(taxRate => {
						vm.payload.tax = +vm.payload.cost * taxRate/100
					})
				})
			}
		},
		deleteExpense() {
			let vm = this

			this.deleteConfirmModalVisible = false

			this.postData("Expense/delete",{id:this.record.id},true).then(response => {
				if (response.success) {
					vm.$emit("expenseDeleted")
					vm.alertSuccess("Expense deleted")
				}
			})
			
		},
		closeModal() {
			this.$emit("closeModal")
		},
		save() {
			this.$emit("save",this.payload)
		},
		unlock() {
			this.payload.reviewed_by = 0
		},
		rotateImg(dir) {
			let vm = this

			let payload = {
				id: this.record.image_id,
				rotate_direction: dir
			}

			this.postData("ReceiptImage/rotate",payload).then(response => {
				//strip query string, and then add another random one

				vm.imgUpdateRand = Math.random()

				vm.$forceUpdate()
			})
		},
		rotatePOImg(dir) {

		},
		expenseApprovedToggle(value) {
			if (value) {
				this.payload.denied = false
				this.approved = 1
				this.reviewed_by = this.$store.userDetails.id
			}
			else if (!this.payload.denied) {
				this.reviewed_by = 0
			}
		},
		expenseDeniedToggle(value) {
			if (value) {
				this.payload.approved = false
				this.approved = 0
				this.reviewed_by = this.$store.userDetails.id
			}
			else if (!this.payload.approved) {
				this.reviewed_by = 0
			}
		},
		unProcess() {
			let vm = this

			let payload = {
				id: this.record.id,
				processed: 0
			}

			this.postData("Expense/save",payload,true).then(response => {
				if (response.success) {
					vm.$emit("unProcessed")
					vm.unprocessedConfirmModalVisible = false
				}
			})
		},
		unReview() {
			let vm = this

			let payload = {
				id: this.record.id,
				approved: 0,
				reviewed_by: 0,
				denied: 0,
				denied_reason: ""
			}

			this.postData("Expense/save",payload,true).then(response => {
				if (response.success) {
					vm.payload.reviewed_by = 0
					vm.payload.approved = 0
					vm.payload.denied = 0
					vm.payload.denied_reason = ""

					vm.$emit("unReviewed")
					vm.unreviewConfirmModalVisible = false
				}
			})
		},
		groupSelected(group_id,code_id) {

			let vm = this

			let params = {
				filters: [
					["group_id",group_id]
				]
			}

			vm.spinner(true)

			return new Promise((resolve,reject) => {
				vm.getJSON("ExpenseCode/get",params).then(response => {

					vm.spinner(false)

					let expenseCodesFiltered = response.data.map(code => {
						code.display = code.code + ": " + code.description

						return code
					})

					vm.expenseCodesFilteredOptions = vm.optionify(expenseCodesFiltered,"display")

					if (code_id) {
						vm.payload.code_id = parseInt(code_id)
					}

					resolve(response)
				})
			})
		},
		jobSelected(id,resource) {
			this.fetchJobPurchaseOrders(id,resource == 'Job' ? 'job_id' : 'service_id')
		},
		fetchJobPurchaseOrders(job_id,job_key) {
			let vm = this

			return new Promise((resolve,reject) => {

				let params = {
					filters: [
						[job_key,job_id]
					],
					include: ["Job","Service"]
				}

				vm.getJSON("PurchaseOrder/get",params).then(response => {

					if (response.success) {
						vm.purchaseOrders = response.data
					}

					resolve(response)
				})

			})
		},
		fetchMessages() {
			let vm = this

			let params = {
				filters: [
					["thread_id",this.record.message_thread_id]
				],
				include: [
					{
						model: "User",
						fields: ["slug","id","first_name","last_name"]
					}
				]
			}
			return new Promise((resolve,reject) => {
				vm.getJSON("Message/get",params).then(response => {
					if (response.success) 
						vm.payload.MessageThread.Message = response.data
					
					resolve(response)
				})
			})
		},
		fetchSuppliers() {
			let vm = this

			let params = {
				filters: [
					["is_supplier",1]
				]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("Contact/get",params).then(response => {
					if (response.success) 
						vm.suppliers = response.data
					
					resolve(response)
				})
			})
		},
		fetchServicesLocal() {
			let vm = this

			let params = {
				fields: this.jobFields,
				filters: [
					['archived',0]
				],
				include: [{
					model: "Contact",
					fields: ["name"]
				}]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("Service/get",params).then(response => {

					if (response.success) {

						vm.serviceOptionsLocal = vm.optionify(response.data.map(job => {
							if ("Customer" in job && job.Customer)
								job.optionText = job.job_num+": "+job.Customer.name
							else
								job.optionText = job.job_num

							return job
						}),"optionText")


					}

					resolve(response)
				})
			})
		},
		fetchProjects() {
			let vm = this

			let params = {
				fields: this.jobFields,
				filters: [
					['archived',0]
				]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("Job/get",params).then(response => {

					if (response.success) {
						vm.projectOptionsLocal = vm.optionify(response.data.map(job => {
							job.optionText = job.job_num+": "+job.job_name

							return job
						}),"optionText")
					}
					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this, promises = []

			if (!this.projectOptionsExternal || this.projectOptionsExternal.length == 0)
				promises.push(this.fetchProjects())
			else
				this.projectOptionsLocal = this.projectOptionsExternal

			if (!this.serviceOptionsExternal || this.serviceOptionsExternal.length == 0)
				promises.push(this.fetchServicesLocal())
			else
				this.serviceOptionsLocal = this.serviceOptionsExternal

			if (this.qboIsActive) {
				promises.push(this.fetchQBOCreditCards())
				promises.push(this.fetchQboSalesTaxes())
			}

			this.fetchSuppliers()

			if (promises.length > 0) {
				Promise.all(promises).then(response => {
					vm.setPayload()
				})
			}
			else
				vm.setPayload()
		}
	},
	created() {
		this.fetchData()
	}
}
</script>